export default {
  manageTranslation: true, // to be activated after API and message channel Integration
};
